import { useContext } from 'react';
import StepItem from 'components/StepItem';
import { MultiStepFormContext } from '@kanda-libs/ks-component-ts';
import { STEPS_CLASS_NAMES } from './constants';

const Steps = ({}) => {
  const { steps } = useContext(MultiStepFormContext);

  return (
    <div className={STEPS_CLASS_NAMES.container}>
      {steps.map((label, index) => (
        <StepItem
          key={label}
          index={index}
          label={label as unknown as number}
        />
      ))}
    </div>
  );
};

export default Steps;
